export enum CardsOrientation {
  HORIZONTAL,
  VERTICAL,
  WRAPPED
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/card-list/enums/cards-orientation.enum.ts